<template>
  <div>
    <b-message type="is-primary">
      {{ $t("affiliateToolsDesc") }}
    </b-message>
    <input ref="copyText" type="hidden" :value="href" />
    <b-field class="mt-3">
      <b-input type="text" :value="href" expanded :disabled="isLoading" style="max-width: 600px" />
      <p class="control">
        <b-button
          :loading="isLoading"
          :disabled="isLoading"
          class="is-primary"
          icon-left="checkbox-multiple-blank-outline"
          @click="copyLink()"
        />
      </p>
    </b-field>
  </div>
</template>

<script>
//import {db} from '@/firebase'

export default {
  name: "AffiliateTools",
  components: {},
  props: {
    referralId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    href() {
      return `https://app.goqonda.io/?ref=${this.referralId}`;
    },
    isLoading() {
      if (this.referralId == "") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    activeTab() {
      localStorage.activeTab = this.activeTab;
    },
  },
  methods: {
    copyLink() {
      try {
        this.$refs.copyText.setAttribute("type", "text");
        this.$refs.copyText.select();
        document.execCommand("copy");
        this.$buefy.toast.open({
          message: this.$t("copied"),
          type: "is-success",
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: this.$t("notCopied"),
          type: "is-danger",
        });
      }
      this.$refs.copyText.setAttribute("type", "hidden");
    },
  },
  firestore() {
    return {};
  },
};
</script>
